import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameManager} from '../UIGameManager'
import {UIGamePlayerInformationView} from '../ui_game_players/UIGamePlayerInformationView'
import {UIGameMechanic} from '../UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {TurnState} from '@colonist/game-states'

export class UIGamePlayerInformationSpecialBuildPhaseFlagController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly playerInformation: UIGamePlayerInformationView
    private readonly flagView: SpriteView

    constructor(uiGameManager: UIGameManager, playerInformation: UIGamePlayerInformationView) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.playerInformation = playerInformation

        const myColor = this.uiGameManager.gameController.myColor
        this.flagView = myColor == this.playerInformation.player.color ? this.creatMyFlagView() : this.createOpponentFlagView()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated: this.updateSpecialBuildPhaseFlag(); break
            default: break
        }
    }

    private creatMyFlagView(): SpriteView {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const flagSize = this.playerInformation.specialIconView.height
        const flagView = new SpriteView(0, 0, flagSize, flagSize, this.playerInformation, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_special_build_phase_flag))
        flagView.parent.removeChild(flagView)
        return flagView
    }

    private createOpponentFlagView(): SpriteView {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const flagSize = UIUtilsEjsVariables.isUserOnMobileAppOrWeb ? this.playerInformation.specialIconView.height : this.playerInformation.specialIconView.width
        const flagView = new SpriteView(0, 0, flagSize, flagSize, this.playerInformation, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_special_build_phase_flag))
        flagView.parent.removeChild(flagView)
        return flagView
    }

    private updateSpecialBuildPhaseFlag() {
        this.resetPlayerInformationFlatView()
        if(this.uiGameManager.gameController.currentState.turnState != TurnState.SpecialBuildPhase) return
        if(this.uiGameManager.gameController.currentState.currentTurnPlayerColor != this.playerInformation.player.color) return

        if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) {
            this.playerInformation.specialIconView.addChild(this.flagView)
            return
        }

        this.playerInformation.specialIconView.addSpriteView(this.flagView)
    }

    private resetPlayerInformationFlatView() {
        if(this.flagView == undefined) return
        if(this.flagView.parent == undefined) return
        this.playerInformation.specialIconView.removeSpriteView(this.flagView)
    }
}
